import axios from 'axios';
import { API, API_URL } from '../constants';
import { getAllIndustriesAction } from '../store/industries/actions';
import { getLocalStorageByKey } from '../utils/localStorage';

export const getIndustries = () => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.INDUSTRY.GET,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        dispatch(getAllIndustriesAction(data));
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};

export const addIndustry = name => {
  return async dispatch => {
    return await axios({
      method: 'POST',
      url: API_URL + API.POST.INDUSTRY.ADD,
      data: { name },
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};
